// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const carpenter = defineModel({
  id: "carpenter",
  batchId: "future",
  name: "Carpenter",
  tags: ["building","carpenter","low-poly","age-of-mcp","future"],
  summary: "Works plank into handles, frames, furniture and fittings for many builds.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.45, 1.1), color: "#a8804a", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [-0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [-0.75, 0.365, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a5a30", position: [0.75, 0.365, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.75, 0.45, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.75, 0.45, 0.75] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.9, 1.1), color: "#a8804a", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [-0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [-0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [0.75, 0.59, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.75, 0.7, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.75, 0.7, -0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [-0.75, 0.7, 0.75] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.4, 4), color: "#6b4a26", position: [0.75, 0.7, 0.75] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.8, 0.14, 1.8), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.9, 1.1), color: "#a8804a", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [-0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [0.75, 0.59, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [-0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.9, 0.1), color: "#7a5a30", position: [0.75, 0.59, 0.55] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, 0.305], rotation: [0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.800608), color: "#7a4a36", position: [0, 1.25, -0.305], rotation: [-0.602983, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#5a3526", position: [0, 1.46, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.56] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.04), color: "#8a5f33", position: [-0.39, 0.31, 0.66], rotation: [0, 0, 0.3] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.04), color: "#8a5f33", position: [-0.25, 0.31, 0.66], rotation: [0, 0, -0.3] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.04), color: "#8a5f33", position: [0.25, 0.31, 0.66], rotation: [0, 0, 0.3] },
      { geometry: new THREE.BoxGeometry(0.04, 0.34, 0.04), color: "#8a5f33", position: [0.39, 0.31, 0.66], rotation: [0, 0, -0.3] },
      { geometry: new THREE.BoxGeometry(0.78, 0.05, 0.06), color: "#5f3f20", position: [0, 0.48, 0.66] },
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.22), color: "#8a5f33", position: [0.57, 0.165, 0.5] },
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.22), color: "#8a5f33", position: [0.63, 0.215, 0.5] },
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.22), color: "#8a5f33", position: [0.57, 0.265, 0.5] },
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.22), color: "#8a5f33", position: [0.63, 0.315, 0.5] },
      { geometry: new THREE.BoxGeometry(0.7, 0.05, 0.22), color: "#8a5f33", position: [0.57, 0.365, 0.5] },
    ] },
  ],
  animations: [],
});
